const colors = {
	muted: '#475569',
	link: '#006FEE',
	disabled: '#e5e5e5',
	default: {
		DEFAULT: '#11181C',
	},
	primary: {
		light: '#66AAF9',
		DEFAULT: '#006FEE',
		dark: '#005BC4',
	},
	secondary: {
		light: '#AE7EDE',
		DEFAULT: '#7828C8',
		dark: '#6020A0',
	},
	success: {
		light: '#74DFA2',
		DEFAULT: '#17C964',
		dark: '#12A150',
	},
	warning: {
		light: '#F9C97C',
		DEFAULT: '#F5A524',
		dark: '#C4841D',
	},
	error: {
		light: '#ef4444',
		DEFAULT: '#dc2626',
		dark: '#b91c1c',
	},
	grey: {
		light: '#e4e4e7',
		DEFAULT: '#d4d4d8',
		dark: '#a1a1aa',
	},
};

export { colors };
